var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 800,
    viewBox: "0 0 360 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_389_2174)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 800,
    fill: "#2A0969"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8628,
    cy: 13.626,
    r: 192.415,
    transform: "rotate(-34.7312 30.8628 13.626)",
    stroke: "#7ABFEB",
    strokeOpacity: 0.08,
    strokeWidth: 3.89827
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.9035,
    cy: 13.4523,
    r: 169.67,
    transform: "rotate(-34.7312 29.9035 13.4523)",
    stroke: "#7ABFEB",
    strokeOpacity: 0.08,
    strokeWidth: 3.89827
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8627,
    cy: 13.6261,
    r: 140.033,
    transform: "rotate(-34.7312 30.8627 13.6261)",
    stroke: "#7ABFEB",
    strokeOpacity: 0.08,
    strokeWidth: 3.89827
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.469,
    cy: 449.469,
    r: 192.415,
    transform: "rotate(-34.7312 394.469 449.469)",
    stroke: "#7ABFEB",
    strokeOpacity: 0.08,
    strokeWidth: 3.89827
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.51,
    cy: 449.295,
    r: 169.67,
    transform: "rotate(-34.7312 393.51 449.295)",
    stroke: "#7ABFEB",
    strokeOpacity: 0.08,
    strokeWidth: 3.89827
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.469,
    cy: 449.469,
    r: 140.033,
    transform: "rotate(-34.7312 394.469 449.469)",
    stroke: "#7ABFEB",
    strokeOpacity: 0.08,
    strokeWidth: 3.89827
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.4692,
    cy: 793.469,
    r: 192.415,
    transform: "rotate(-34.7312 14.4692 793.469)",
    stroke: "#7ABFEB",
    strokeOpacity: 0.08,
    strokeWidth: 3.89827
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.51,
    cy: 793.295,
    r: 169.67,
    transform: "rotate(-34.7312 13.51 793.295)",
    stroke: "#7ABFEB",
    strokeOpacity: 0.08,
    strokeWidth: 3.89827
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.4691,
    cy: 793.469,
    r: 140.033,
    transform: "rotate(-34.7312 14.4691 793.469)",
    stroke: "#7ABFEB",
    strokeOpacity: 0.08,
    strokeWidth: 3.89827
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271 -33.4713L267.517 84.6414L317.982 115.328L368.448 146.016L467.938 86.3533L468.947 -31.7805L370.49 -93.1335L271 -33.4713Z",
    stroke: "#301873",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.206 -17.5985L293.631 69.2071L331.015 91.7627L368.398 114.318L442.091 70.4752L442.833 -16.3461L369.899 -61.4417L296.206 -17.5985Z",
    stroke: "#301873",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.815 -4.60321L316.01 56.5877L342.177 72.486L368.344 88.3843L419.932 57.4754L420.454 -3.7265L369.403 -35.5122L317.815 -4.60321Z",
    stroke: "#301873",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-119.591 325.168L-123.802 467.944L-62.7985 505.039L-1.79528 542.134L118.47 470.013L119.689 327.212L0.674 253.047L-119.591 325.168Z",
    stroke: "#301873",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-89.1224 344.355L-92.2344 449.287L-47.045 476.552L-1.85565 503.818L87.2259 450.82L88.1223 345.869L-0.0408855 291.357L-89.1224 344.355Z",
    stroke: "#301873",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-63.0001 360.064L-65.1829 434.032L-33.5515 453.25L-1.92003 472.468L60.4393 435.105L61.0712 361.124L-0.640769 322.701L-63.0001 360.064Z",
    stroke: "#301873",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266 714.529L262.517 832.641L312.982 863.328L363.448 894.016L462.938 834.353L463.947 716.22L365.49 654.867L266 714.529Z",
    stroke: "#301873",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.206 730.401L288.631 817.207L326.015 839.763L363.398 862.318L437.091 818.475L437.833 731.654L364.899 686.558L291.206 730.401Z",
    stroke: "#301873",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.815 743.397L311.01 804.588L337.177 820.486L363.344 836.384L414.932 805.475L415.454 744.273L364.403 712.488L312.815 743.397Z",
    stroke: "#301873",
    strokeWidth: 4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_2174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.8fed4c66f766eebfa794739d79f83189.svg";
export { ForwardRef as ReactComponent };